module.exports = __webpack_public_path__ + "img/wusong-night-balanced.b159a8fa.png";